import { sortOptionsISelect } from '../helpers/sortISelect';
import { LanguageLevel } from '../model/enumerations/language-level.model';
import { ISelect } from '../model/iSelect';

export const languageLevelEnum = (): Array<ISelect> => {
  const languageLevel: Array<ISelect> = [
    {
      label: "Básico",
      value: LanguageLevel.BASIC,
    },
    {
      label: "Intermedio",
      value: LanguageLevel.INTERMEDIATE,
    },
    {
      label: "Avanzado",
      value: LanguageLevel.ADVANCED,
    },
  ];
  return sortOptionsISelect(languageLevel);
};
